var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElRate',{attrs:{"disabled":"","value":_vm.row.rate,"colors":_vm.ratingColors}})
}
var staticRenderFns = []

export { render, staticRenderFns }